<div class="row">
    <div class="col-12 col-md-3">
        <div class="card rounded-0" >
            <div class="card-body">
                <form #f="ngForm" (ngSubmit)="f.valid && submit()" novalidate>
                    <h3 class="fs-4 fw-bold">Voucher</h3>
                    <div class="mb-3">
                        <label for="voucher_code" class="form-label">Voucher Code <em>*</em></label>
                        <input type="text" class="form-control" id="voucher_code" name="voucher_code" #voucher_code="ngModel" [(ngModel)]="data.voucher_code" required>
                        <div *ngIf="f.submitted && voucher_code.invalid" class="invalid-feedback">
                            <div *ngIf="voucher_code.errors.required">Voucher Code is required</div>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label for="player_code" class="form-label">Player Code</label>
                        <input type="text" class="form-control" id="player_code" name="player_code" #player_code="ngModel" [(ngModel)]="data.player_code">
                    </div>
                    <div class="mb-3">
                        <label for="remark" class="form-label">Remark</label>
                        <input type="text" class="form-control" id="remark" name="remark" #remark="ngModel" [(ngModel)]="data.remark">
                    </div>
                    <div class="mb-3">
                        <label for="status" class="form-label">Status <em>*</em></label>
                        <select class="form-control" name="status" #status="ngModel" [(ngModel)]="data.status" required>
                            <option [value]="2">New</option>
                            <option [value]="1">Played</option>
                            <option [value]="0">Disabled</option>
                        </select>
                    </div>
                    <div class="mb-3">
                        <label for="winning" class="form-label">Winning <em>*</em></label>
                        <select class="form-control" name="winning" #winning="ngModel" [(ngModel)]="data.winning" required>
                            <option [value]="section.value" *ngFor="let section of sections">{{section.label}}</option>
                        </select>
                    </div>
                    <button type="submit" class="btn btn-primary">Update</button>
                </form>
            </div>
        </div>
